<template>
  <div class="settings-dashboard">
    <!-- Header Section -->
    <b-row>
      <b-col
        cols="12"
        class="mb-2 d-flex align-items-center justify-content-between"
      >
        <div>
          <h1 class="h3 font-weight-bolder mb-0">
            <feather-icon
              icon="ActivityIcon"
              size="24"
              class="mr-1 mb-1"
            />Trading & Risk Management
          </h1>
          <span class="text-muted"
            >Manage odds, markets, risk exposure, and data feed mapping</span
          >
        </div>
      </b-col>
    </b-row>

    <b-row>
      <!-- Configuration Sections -->
      <b-col cols="12">
        <b-row
          style="
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 10px;
          "
        >
          <div v-for="(section, index) in configSections" :key="index">
            <b-card
              class="border-0 shadow-sm config-card"
              :class="section.status"
              @click="navigateTo(section.route)"
              style="height: 100%"
            >
              <div class="d-flex flex-column align-items-start">
                <div
                  class="rounded mr-1 d-flex justify-content-center align-items-center"
                  :class="section.color"
                  style="width: 44px; height: 44px"
                >
                  <feather-icon :icon="section.icon" size="24" />
                </div>
                <div class="flex-grow-1">
                  <h3 class="m-0 py-2" style="font-weight: 900">
                    {{ section.title }}
                  </h3>
                  <p class="text-muted m-0 text-description">
                    {{ section.description }}
                  </p>
                  <small class="text-muted">{{ section.stats }}</small>
                </div>
              </div>
            </b-card>
          </div>
        </b-row>
      </b-col>
    </b-row>

    
  </div>
</template>

<script>
import { BCard, BCol, BRow, BButton, BIcon } from "bootstrap-vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BIcon,
  },
  data() {
    return {
      configSections: [
        {
          title: "Racing Trading Dashboard",
          description:
            "Monitor and manage racing markets, odds, and trading activities in real-time.",
          icon: "ActivityIcon",
          color: "icon-purple",
          route: "trading-racing",
        },
        {
          title: "Sports Trading Dashboard",
          description:
            "Monitor and manage sports markets, odds, and trading activities in real-time.",
          icon: "TrendingUpIcon",
          color: "icon-red",
          route: "trading-sports",
        },
        // {
        //   title: "Feed Mapping Workbench",
        //   description:
        //     "Map and reconcile racing data feeds from RAS and BetMakers. Real-time synchronization and automated matching.",
        //   icon: "GitBranchIcon",
        //   color: "icon-blue",
        //   route: "trading-mapping",
        // },
        {
          title: "Event and Odds Management",
          description:
            "Set and adjust odds for racing and sports markets. Manage margins and overrounds.",
          icon: "DivideIcon",
          color: "icon-green",
          route: "trading",
        },
        // {
        //   title: "Market Management",
        //   description:
        //     "Create, suspend, and manage betting markets across all racing and sports events.",
        //   icon: "ShoppingBagIcon",
        //   color: "icon-orange",
        //   route: "trading-sports-config",
        // },
           {
          title: "League and Market Management",
          description:
            "Create, suspend, and manage league ignore config and market group config.",
          icon: "ShoppingBagIcon",
          color: "icon-orange",
          route: "trading-sports-config",
        },
        {
          title: "Risk Exposure",
          description:
            "Monitor liability across all markets. Set limits and manage exposure in real-time.",
          icon: "ShieldIcon",
          color: "icon-purple",
          route: "settings-customer-profiles-and-betting-templates",
        },
        // {
        //   title: "Live Trading",
        //   description:
        //     "Real-time trading dashboard for in-play markets. Monitor and adjust odds during events.",
        //   icon: "WifiIcon",
        //   color: "icon-red",
        //   route: "",
        //   status: "disabled",
        // },
        {
          title: "Settlement",
          description:
            "Settle markets, process results, and manage voided bets and refunds.",
          icon: "CheckCircleIcon",
          color: "icon-teal",
          route: "",
        },
      ],
    };
  },
  computed: {
    ...mapState("auth", ["user", "permissions"]),
  },
  created() {
    this.checkPermission();
  },

  methods: {
    navigateTo(section) {
      if (!section) return;
      this.$router.push({ name: section });
    },
    addNewUser() {},
    reviewAuditLogs() {},
    updateRiskProfiles() {},
    securityCheck() {},
    checkPermission() {
      this.configSections = [...this.configSections].filter(
        (i) =>
          !(
            this.permissions.role === "none" &&
            i.route === "settings-user-management"
          ) &&
          !(
            this.permissions.server === "none" &&
            i.route === "settings-system-configuration"
          )
      );
    },
  },
};
</script>

<style scoped>
.settings-dashboard {
  background-color: #f8f9fa;
  min-height: 100vh;
}

.config-card {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 10px;
}

.config-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.action-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  margin: -8px;
}

.action-item:hover {
  background-color: #f8f9fa;
}

.activity-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.bg-purple {
  background-color: #8b5cf6 !important;
}

.text-purple {
  color: #8b5cf6 !important;
}

.bg-opacity-10 {
  opacity: 0.1;
}

@media (max-width: 768px) {
  .settings-dashboard {
    padding: 1rem !important;
  }

  .h3 {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .activity-item .d-flex {
    align-items: flex-start !important;
  }

  .activity-dot {
    margin-top: 4px;
  }
}

@media (min-width: 1440px) {
  .text-description {
    width: 80%;
  }
}

.icon-blue {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.icon-green {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}
.icon-orange {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}
.icon-purple {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}
.icon-red {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
  color: white;
}
.icon-teal {
  background: linear-gradient(135deg, #30cfd0 0%, #330867 100%);
  color: white;
}
.disabled {
    opacity: 0.55;
    filter: grayscale(100%);
    cursor: not-allowed;
    pointer-events: none;
}
</style>
